module.exports = __webpack_public_path__ + "static/media/clock-history 3.98609c36.svg";